import dayjs from 'dayjs'

// 时间格式化
export function formatTime(value, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!value) {
    return
  }
  if (value.toString().length === 10) {
    return dayjs(value * 1000).format(format)
  }
  if (value.toString().length === 13) {
    return dayjs(value * 1).format(format)
  }
}
